import {FC} from 'react';
import {Stack} from '@mui/system';
import {CIRCLE_STATUSES} from '../../constants/status';
import {get} from 'lodash';
import {Typography} from '@mui/material';

export const MapLegend: FC = () => {
  return (
    <Stack direction="row" gap={4}>
      {Object.keys(CIRCLE_STATUSES).map((status) => {
        if (status === 'EMPTY') return null;
        return (
          <Stack key={status} direction="row" gap={1} alignItems="center">
            <Stack
              sx={{
                width: 14,
                height: 14,
                borderRadius: '50%',
                backgroundColor: get(CIRCLE_STATUSES, `${status}.color`),
              }}
            />
            <Typography sx={{fontSize: 14}}>{get(CIRCLE_STATUSES, `${status}.label`)}</Typography>
          </Stack>
        );
      })}
    </Stack>
  );
};
